module.exports = __webpack_public_path__ + "01f43047/img/cadBim.e369a02a.png";